import React from 'react'
import "./buttonScrollTop.scss"
import {FaArrowUp} from "react-icons/fa"
export const ButtonScrollTop = () => {
  return (
    <div className="div-button-scrollTop">
        <a href='#'>
        <button><FaArrowUp /></button>
        </a>
    </div>
  )
}
